import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CoursBar from './cours_bar';
import CoursBarHead from './cours_bar_head';
import axios from 'axios';
import { API_URL } from '../../config';
import { Link, useHistory } from 'react-router-dom';
import ApiService from '../../services/ApiService';
import EventDetail from './eventDetails';
import CustomButtons from '../Elements/Buttons/customButton';
import './pulpit.css';

const styleEventList = {
    'overflowY': 'scroll',
    height: '500px',
    'marginTop': '8px',
    padding: '8px 24px',
};
const groupHeader = [
    'GRUPA',
    'NUMER UMOWY',
    'STATUS',
    'UCZESTNIK',
    'PŁATNIK',
    'DATA OD/ DATA DO',
    'KWOTA UMOWY',
    'OPŁATA OCZEKUJĄCA',
    ' ',
];


const ActiveCourse = (props) => {
    const [res, setResponse] = useState([]);
    const [resII, setResponseII] = useState([]);
    const [getResponse, setGetResponse] = useState(0);
    const history = useHistory();
    const apiService = ApiService.getInstance();
    const getSubaccountsURL = `${API_URL}GetSubaccounts`;
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    const [userToShow, setUserToShow] = useState('');
    const [eventList, setEventList] = useState([]);
    const [choosenBar, setChoosenBar] = useState({
        regular: false,
        personal: false,
        work: false,
        events: false,
    });
    //onLineSchedulePayment
    const payload = {
        keyController: 'usersSchedules',
        usersID: props.userID,
        current_LocalizationsID: '0',
    };
    let eventsList = [];
    let eventListID = [];
    let regularEvent = [];
    let personalEvent = [];
    let workshopEvent = [];
    let singleEvent = [];
    const getCourseForUser = () => {
        if (
            payload.usersID != null ||
            payload.usersID != undefined ||
            payload.usersID != ""
        ) {
            apiService.apiPost('CalculateProductForUser', payload, (response) => {
                setEventList(response.data.responseBody.body.body);
                eventList = response.data.responseBody.body.body;
            });
        }
    };

    const payloadII = {
        //"getAllPaymets",
        keyController: 'contracts',
        usersID: props.userID,
        current_LocalizationsID: '0',
    };
    const methodProxySend = () => {
        apiService.apiPost('CalculateProductForUser', payloadII, (response) => {
            if (response.success) {
         
                setResponseII(response.data.responseBody.body.body);
            }
        });
    };

    function tegetRelationsUsersst() {
        axios
            .get(getSubaccountsURL, config)
            .then((response) => {
           
                setResponse(response.data);
                setGetResponse(response.data.length);
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    history.push('/Error_sesja_wygasla');
                }
            });
    }
    const configAA = {};
    const getUsersContracts = async () => {
        await apiService.asyncApiPost('GetWWWUserContracts', config).then((response) => {
            if (response.responseStatusCode != 401) {
                let dataSort = response.responseBody.body.sort(function (a, b) {
                    if (a.contractsID < b.contractsID) {
                        return 1;
                    }
                    if (a.contractsID > b.contractsID) {
                        return -1;
                    }
                    return 0;
                });

             
            }
        });

        return 'Finished methodCheckUserEntryFee';
    };

    useEffect(() => {
        getUsersContracts();
        tegetRelationsUsersst();
        getCourseForUser();
        methodProxySend();
    }, [props.userID]);
    function changeUser(id) {
        setUserToShow(id);
    }
    let widthScreen = window.innerWidth
    useEffect(()=>{
        
    },[widthScreen])
    function showChoosenUserEvent() {
        // if(userToShow.length != 0){
        //  const result =  eventList.filter((course)=> course)
        // }else{
        //     eventsList = eventList
        // }
        // for(var i = 0; i < resII.length;i++){
        //     for(var j = 0; j < eventList.length;j++){
        //             if(eventList[j].courseHeadingName ==resII[i].courseHeadingName)
        //             console.log("--------+----------------");
        //             console.log(resII[i])
        //             console.log(eventList[j]);
        //             console.log("++++++++++++++++++++++")
        //     }
        // }
        // for(var i = 0; i < eventList.length;i++){
        //     console.log(
        //         eventList[i].courseHeadingName
        //     )
        // }
        // console.log()
    }
   
    return (
        <>
            <div className="filter_eventList">
                <p style={{ color: 'black' }}>Pokaż dla:</p>
                <select
                    onChange={(e) => changeUser(e.target.value)}
                    className="select_filterEventList"
                >
                    <option value="">Wszyscy</option>
                    <option value={props.userID}>{props.userName}</option>
                    {res.map((user, i) => {
                        return (
                            <option key={i} value={user.usersRelationsID}>
                                {user.firstName + ' ' + user.lastName}
                            </option>
                        );
                    })}
                </select>
            </div>
            <div className="dashbord_eventList" style={styleEventList}>
                <CoursBar
                    onSelect={(status) =>
                        setChoosenBar({
                            ...choosenBar,
                            regular: status,
                        })
                    }
                    name={'Zajęcia regularne'}
                    tittle={groupHeader}
                ></CoursBar>
                <div
                    className={choosenBar.regular ? 'selectedBarContent' : 'noneSelectedBarContent'}
                >
                    {resII.map((element,i) => {
                        if (element.productsLevel2DVID == 1 && element.contractStatusesDVID == 2) {
                            if(userToShow == ""|| element.contracts_UsersID == userToShow){
                            regularEvent.push(element)
                            return <EventDetail key={i} data={element}></EventDetail>;}else{}
                        }
                    })}
                     {regularEvent.length == 0?<div className="noEventWrapper"><p className="noEventInEventList">W chwili obecnej nie masz aktywnych kursów. Zobacz ofertę i zacznij już dziś</p><a target="_blank"  href="https://egurrola.com/style-taneczne/" className="courseMore_link margin-top-32 "  >
                           
                           <CustomButtons clickFunction={()=>{}} classButton="solid" size="small">
                   SPRAWDŹ
                           </CustomButtons>
                       </a></div>:""}
                </div>
                <CoursBar
                    onSelect={(status) =>
                        setChoosenBar({
                            ...choosenBar,
                            personal: status,
                        })
                    }
                    name={'Zajęcia indywidualne'}
                    tittle={groupHeader}
                ></CoursBar>
                <div
                    className={
                        choosenBar.personal ? 'selectedBarContent' : 'noneSelectedBarContent'
                    }
                >
                    {resII.map((element) => {
                        if (element.productsLevel2DVID == 6) {
                             personalEvent.push(element)

                            return (
                                <p>
                                    {element.courseHeadingName +
                                        '' +
                                        element.courseDanceStyle +
                                        '' +
                                        element.localizationName +
                                        '' +
                                        element.weekDayName +
                                        '' +
                                        element.timeFrom}
                                </p>
                            );
                        }
                    })}
                     {personalEvent.length == 0?<p className="noEventInEventList">Brak aktywnych zajęć indywidualnych</p>:""}
                </div>
                <CoursBar
                    onSelect={(status) =>
                        setChoosenBar({
                            ...choosenBar,
                            work: status,
                        })
                    }
                    name={'Warsztaty'}
                    tittle={groupHeader}
                ></CoursBar>
                <div className={choosenBar.work ? 'selectedBarContent' : 'noneSelectedBarContent'}>
                    {resII.map((element) => {
                        if (element.productsLevel2DVID == 5) {
                             workshopEvent.push(element)
                            return (
                                <p>
                                    {element.courseHeadingName +
                                        ' ' +
                                        element.courseDanceStyle +
                                        ' ' +
                                        element.localizationName +
                                        ' ' +
                                        element.weekDayName +
                                        ' ' +
                                        element.timeFrom}
                                </p>
                            );
                        }
                    })}
                    {workshopEvent.length == 0?<p className="noEventInEventList">Brak aktywnych warsztatów</p>:""}
                </div>
                <CoursBar
                    onSelect={(status) =>
                        setChoosenBar({
                            ...choosenBar,
                            events: status,
                        })
                    }
                    name={'Eventy'}
                    tittle={groupHeader}
                ></CoursBar>
                <div
                    className={choosenBar.events ? 'selectedBarContent' : 'noneSelectedBarContent'}
                >
                    {resII.map((element) => {
                        if (element.productsLevel2DVID == 4) {
                            singleEvent.push(element)
                            return (
                                <p>
                                    {element.courseHeadingName +
                                        ' ' +
                                        element.courseDanceStyle +
                                        ' ' +
                                        element.localizationName +
                                        ' ' +
                                        element.weekDayName +
                                        ' ' +
                                        element.timeFrom}
                                </p>
                            );
                        }
                    })}
                    {singleEvent.length == 0?<p className="noEventInEventList">Brak aktywnych eventów</p>:""}
                    
                </div>

              
            </div>
        </>
    );
};

export default ActiveCourse;
